import { useMemo, useState } from "react";
import {
  ProjectRevisionReview,
  type RevisionReviewServices,
} from "@proof/authoring";
import type { Project, ImportReport } from "@proof/core";
import { DocumentImport } from "./DocumentImport";
import { Modal } from "./components";
import { useWorkspaceTransport } from "./WorkspaceContext";

export function DocumentRevision({
  project,
  onClose,
  onApply,
}: {
  project: Project;
  onClose: () => void;
  onApply: (project: Project) => void;
}) {
  const [baseline] = useState(() => structuredClone(project));
  const [incoming, setIncoming] = useState<Project>();
  const [report, setReport] = useState<ImportReport>();
  const transport = useWorkspaceTransport();
  const services = useMemo<RevisionReviewServices>(
    () => ({
      ...transport.proofServices,
      validateResources: async (definition, signal) => {
        const response = await transport.request("/documents/package/report", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ project: definition }),
          signal,
        });
        if (!response.ok) throw new Error("Document resources are unavailable");
      },
    }),
    [transport],
  );
  if (!incoming)
    return (
      <DocumentImport
        title="Import revision"
        jsonTenant={project.tenantId}
        onClose={onClose}
        onImport={async (value, report) => {
          setIncoming(value);
          setReport(report);
        }}
      />
    );
  return (
    <Modal title="Merge document revision" onClose={onClose} wide>
      <ProjectRevisionReview
        project={project}
        baseline={baseline}
        incoming={incoming}
        importReport={report}
        services={services}
        onApply={onApply}
        onCancel={onClose}
        onChooseRevision={() => {
          setIncoming(undefined);
          setReport(undefined);
        }}
      />
    </Modal>
  );
}
